import React from 'react'
import MuiButton from '@material-ui/core/Button'
import ThemeConsumer from '@/hoc/ThemeConsumer'
import WithStylesProps from '@/hoc/WithStylesProps'
import Icon from './Icon'
import { fade } from '@material-ui/core/styles/colorManipulator'
import { fonts } from '@/utils/preset'

const ActionButton = props => {
  const { theme, name, type, classes, children, className, ...other } = props
  return (
    <MuiButton
      className={className}
      variant="outlined"
      classes={classes}
      {...other}
    >
      <Icon name={name} />
    </MuiButton>
  )
}

const getStyles = (type, theme) => {
  if (type === 'contrast') {
    return {
      backgroundColor: 'transparent',
      color: theme.text.contrast,
      borderColor: theme.text.contrast
    }
  } else {
    return {
      backgroundColor: 'transparent',
      color: theme.text.default,
      borderColor: theme.text.default
    }
  }
}

const styles = props => {
  const styles = getStyles(props.type, props.theme)
  return {
    root: {
      backgroundColor: styles.background,
      color: styles.color,
      borderColor: styles.color,
      borderRadius: '50%',
      borderWidth: 2,
      width: 40,
      minWidth: 40,
      height: 40,
      fontSize: 14,
      padding: 0,
      fontFamily: fonts.base,
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: fade(styles.color, 0.05),
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        },
        '&:disabled': {
          backgroundColor: 'transparent'
        }
      },
      '&:disabled': {
        color: fade(styles.color, 0.6),
        borderColor: fade(styles.color, 0.6)
      }
    }
  }
}

export default ThemeConsumer(WithStylesProps(styles)(ActionButton))
